define("shared/modifiers/droppable", ["exports", "@ember/service", "ember-modifier"], function (_exports, _service, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"ember-modifier"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let DroppableModifier = (_class = class DroppableModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);
    }

    get domElement() {
      return this.args.named.isWindow ? window : this.element;
    }

    get onDragEnter() {
      return this.args.named.onDragEnter;
    }

    get onDragLeave() {
      return this.args.named.onDragLeave;
    }

    get onDrop() {
      return this.args.named.onDrop;
    }

    get cssClassName() {
      return this.args.named.cssClassName;
    }

    didReceiveArguments() {
      this.dragEnter = this.dragEnter.bind(this);
      this.dragOver = this.dragOver.bind(this);
      this.dragLeave = this.dragLeave.bind(this);
      this.drop = this.drop.bind(this);
      this.domElement.addEventListener('dragenter', this.dragEnter);
      this.domElement.addEventListener('dragover', this.dragOver);
      this.domElement.addEventListener('dragleave', this.dragLeave);
      this.domElement.addEventListener('drop', this.drop);
    }

    dragEnter(event) {
      if (typeof this.onDragEnter === 'function') {
        this.onDragEnter(event);
      }
    }

    dragOver(event) {
      event.preventDefault();

      if (this.cssClassName) {
        const target = event.target;
        target?.classList.add(this.cssClassName);
      }
    }

    dragLeave(event) {
      if (this.cssClassName && this.domElement === this.element) {
        this.domElement.classList.remove(this.cssClassName);
      }

      if (typeof this.onDragLeave === 'function') {
        this.onDragLeave(event);
      }
    }

    drop(event) {
      try {
        if (typeof this.onDrop === 'function') {
          this.onDrop(event);
        } else if (this.onDrop?.state) {
          this.onDrop.perform(event);
        }

        const target = event.target;
        this.cssClassName && target?.classList.remove(this.cssClassName);
      } catch (error) {
        this.alerts.warning(error);
      }
    }

    willDestroy() {
      this.domElement.removeEventListener('dragenter', this.dragEnter);
      this.domElement.removeEventListener('dragover', this.dragOver);
      this.domElement.removeEventListener('dragleave', this.dragLeave);
      this.domElement.removeEventListener('drop', this.drop);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = DroppableModifier;
});